import { render, staticRenderFns } from "./TeacherIndividualEntitlementModal.vue?vue&type=template&id=ea0850c8&scoped=true&"
import script from "./TeacherIndividualEntitlementModal.vue?vue&type=script&lang=js&"
export * from "./TeacherIndividualEntitlementModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ea0850c8",
  null
  
)

export default component.exports